<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;">
        <!-- <el-button type="primary" @click="jump('RCWJSB')">+&nbsp; &nbsp;谈话记录</el-button>
        <el-button type="primary" @click="jumpsss('RCWJSB')">+&nbsp; &nbsp;查看</el-button>
        <el-button type="primary" @click="jum2p('RXSB')">+ &nbsp; &nbsp;多方会商</el-button> -->
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="margin: 0px 0px;background:rgba(255, 255, 255, 1);padding: 10px;">
          <el-form-item label="综合查询">
            <el-input placeholder="账号/学号/身份证号/姓名" v-model="ruleForm.Name"></el-input>
          </el-form-item>

          <el-form-item label="部门">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="ruleForm.DeptID" filterable :options="optionsnew"  :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>

          <el-form-item label="年级">
            <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学位">
            <el-select v-model="ruleForm.Degree" placeholder="请选择学位">
              <el-option label="本科生" value="本科生"></el-option>
              <el-option label="硕士研究生" value="硕士研究生"></el-option>
              <el-option label="博士研究生" value="博士研究生"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="记录类型">
            <el-select v-model="ruleForm.Type" placeholder="请选择记录类型">
              <el-option label="重点台账" value="1"></el-option>
              <el-option label="谈话记录" value="2"></el-option>
              <el-option label="多方会商" value="3"></el-option>
              <!-- <el-option label="多部门会商" value="3"></el-option> -->
              <!-- <el-option label="咨询师上报" value="咨询师上报"></el-option> -->
            </el-select>
          </el-form-item>

          <el-form-item label="上报状态">
            <el-select  v-model="ruleForm.ReportStatus" placeholder="请选择上报状态">
              <el-option label="待风险监控员初审" value="2"></el-option>
              <el-option label="待咨询师评估"    value="33"></el-option>
              <el-option label="待咨询师审核"    value="34"></el-option>
              <el-option label="待危机主管复核"  value="4"></el-option>
              <el-option label="待中心主任审核"  value="6"></el-option>
              <el-option label="心理委员保存"    value="12"></el-option>
              <el-option label="心理委员提交"    value="13"></el-option>
              <el-option label="辅导员保存"      value="14"></el-option>
              <el-option label="已结案"          value="15"></el-option>
              <el-option label="辅导员提交"      value="16"></el-option>
              <el-option label="未结案"          value="17"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="开始时间">
            <el-date-picker v-model="StartTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>

          <el-form-item label="结束时间">
            <el-date-picker v-model="EndTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="时间">
            <el-date-picker v-model="ruleForm.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          </el-form-item> -->
          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
          <el-button type="primary" @click="derivefun()" style="margin-top: 5px;margin-left:10px">导出</el-button>
        </el-form>
      </el-header>
      <div style="height:100%;background-color: #fff;margin-top: 20px;">
        <el-table :data="tableData" stripe style="width: 100%;">

          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          
          <el-table-column label="学生学号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.UserId }}</span>

            </template>
          </el-table-column>

          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="培养单位">
            <template slot-scope="scope">
              <span>{{ scope.row.DeptName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录人">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录时间">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录类型">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordType }}</span>
            </template>
          </el-table-column>

          <el-table-column label="危机调整">
            <template slot-scope="scope">
              <span v-if="scope.row.AdjustBefore =='1'"       style="color: #C20D04;">红色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '2'" style="color: rgba(255, 141, 26, 1);">橙色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '3'" style="color: rgb(233 213 32);">黄色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '4'" style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '5'" style="color: #3AC282;"> 绿色预警</span>
              ->
              <span v-if="scope.row.AdjustNow == '1'"      style="color: #C20D04;">红色预警</span>
              <span v-else-if="scope.row.AdjustNow == '2'" style="color: rgba(255, 141, 26, 1);">橙色预警</span>
              <span v-else-if="scope.row.AdjustNow == '3'" style="color: rgb(233 213 32);">黄色预警</span>
              <span v-else-if="scope.row.AdjustNow == '4'" style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
              <span v-else-if="scope.row.AdjustNow == '5'" style="color: #3AC282;"> 绿色预警</span>
            </template>
          </el-table-column>

          <el-table-column label="记录状态">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="this.Global.pdroleid(1070) || this.Global.pdroleid(1069) || this.Global.pdroleid(1068)" label="学生档案">
            <template slot-scope="scope">
              <span @click="archives(scope.row)" style="cursor: pointer;color: rgb(31, 52, 245);">学生档案</span>
            </template>
          </el-table-column>

          <el-table-column class="xsii" prop="address" label="操作" v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)">
            <template slot-scope="scope" >
              <!-- 心理辅导员 -->
              <div>
                <span v-if="scope.row.RecordStatus == '心理委员提交' || scope.row.RecordStatus == '辅导员保存'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Memcon_modify(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)">内容修改</span>
                <span v-if="scope.row.RecordStatus == '辅导员提交'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Apply(scope.row.TalkNo, scope.row.KeyNo, scope.row.TalkCrisisGrade)">危机调整申请</span>
                <span v-if="scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案' || scope.row.RecordStatus == '心理委员保存'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
                <span v-if="scope.row.RecordStatus == '辅导员提交' || scope.row.RecordStatus == '心理委员提交'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="jump(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)">谈心谈话</span>
                <span v-if="scope.row.RecordStatus == '--' || scope.row.RecordStatus == '未结案'" @click="jump(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)" style="cursor: pointer;color: rgb(31, 52, 245);">谈心谈话</span>
                <span v-if="scope.row.RecordStatus == '辅导员提交' || scope.row.RecordStatus == '心理委员提交' || scope.row.RecordStatus == '--' || scope.row.RecordStatus == '未结案'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="jumpMultiparty(scope.row,0)">多方会商</span>
                <span v-if="(scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '已结案' || scope.row.RecordStatus == '心理委员保存') && scope.row.MTalk!=null" @click="jumpMultiparty(scope.row,1)" style="cursor: pointer;color: rgb(31, 52, 245);">查看多方会商</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column class="xsii" prop="address" label="操作" v-if="this.Global.pdroleid(1079)">
            <template slot-scope="scope">
              <!-- 心理联络 -->
              <div>
                <span v-if="scope.row.RecordStatus == '心理委员提交' || scope.row.RecordStatus == '心理联络员保存'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Memcon_modify(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)">内容修改</span>
                <span v-if="scope.row.RecordStatus == '心理联络员提交'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Apply(scope.row.TalkNo, scope.row.KeyNo, scope.row.TalkCrisisGrade)">危机调整申请</span>
                <span v-if="scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案' || scope.row.RecordStatus == '心理委员保存'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
                <span v-if="scope.row.RecordStatus == '心理联络员提交' || scope.row.RecordStatus == '心理委员提交'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="jump(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)">谈心谈话</span>
                <span v-if="scope.row.RecordStatus == '--' || scope.row.RecordStatus == '未结案'" @click="jump(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)" style="cursor: pointer;color: rgb(31, 52, 245);">谈心谈话</span>
                <span v-if="scope.row.RecordStatus == '心理联络员提交' || scope.row.RecordStatus == '心理委员提交' || scope.row.RecordStatus == '--' || scope.row.RecordStatus == '未结案'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="jumpMultiparty(scope.row,0)">多方会商</span>
                <span v-if="(scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '已结案' || scope.row.RecordStatus == '心理委员保存') && scope.row.MTalk!=null" @click="jumpMultiparty(scope.row,1)" style="cursor: pointer;color: rgb(31, 52, 245);">查看多方会商</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column class="xsii" prop="address" label="操作" v-else-if="this.Global.pdroleid(1069)">

            <template slot-scope="scope" >
              <!-- 1069风险监控员 -->
              <div>
                <span v-if="scope.row.RecordStatus == '待风险监控员初审'" style="cursor:pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_audit(scope.row.TalkNo, scope.row.KeyNo)">风险监控员审核</span>
                <span v-if="scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案'" style="cursor: pointer;color: rgb(31, 52, 245);"  @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
              </div>
            </template>

          </el-table-column>
          <el-table-column class="xsii" prop="address" label="操作" v-else-if="this.Global.pdroleid(1068)">
            <template slot-scope="scope" >
              <!-- 1069危机主管 -->
              <div>
                
                <span v-if="scope.row.RecordStatus == '待危机主管复核'" style="cursor:pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_audit(scope.row.TalkNo, scope.row.KeyNo)">危机主管复核</span>
                <span v-if="scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案'" style="cursor: pointer;color: rgb(31, 52, 245);"  @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="xsii" prop="address" label="操作" v-else-if="this.Global.pdroleid(1070)">
            <template slot-scope="scope" >
             <!-- 1070中心主任 -->
              <div>
                <span v-if="scope.row.RecordStatus == '待中心主任审核'" @click="Crisis_Memcon_audit(scope.row.TalkNo, scope.row.KeyNo)">待中心主任审核</span>
                <span v-if="scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="xsii" prop="address" label="操作" v-else-if="this.Global.pdroleid(1059)">
            <template slot-scope="scope" >
            <!-- 1059心理咨询师 -->
            <div>
              <!-- <span v-if="scope.row.RecordStatus == '待咨询师评估'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="evaluation(scope.row.TalkNo, scope.row.SourceNo,2,scope.row.KeyNo)">咨询师评估</span> -->
              <span v-if="scope.row.RecordStatus == '待咨询师评估'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="EditVisited(scope.row)">咨询师评估</span>
              <!-- 为王海源要求传一scope.row.KeyNo -->
              <span v-if="scope.row.RecordStatus == '待咨询师审核'" style="cursor: pointer;color: rgb(31, 52, 245);">咨询师审核</span>
              <span v-if="scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '未结案' || scope.row.RecordStatus == '已结案'" style="cursor: pointer;color: rgb(31, 52, 245);"  @click="Crisis_Memcon_view(scope.row.TalkNo,scope.row.KeyNo)">查看详情</span>
            </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top:20px;text-align:right" @current-change="handleCurrentChange" :current-page.sync="pageIndexs" :page-size="10"  layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>
      </div>
    </el-container>
    <Crisiscases ref="childdetail"></Crisiscases>
  </div>
</template>
<script>
import Crisiscases from './../Consultant/Crisiscases.vue';
export default {
  components:{
    Crisiscases
  },
  data() {
    return {
      StartTime: '',
      EndTime: '',
      gradedata:[],
      jiaose: '辅导员',
      optionsnew: [],
      Count: 0,
      pageIndexs: 1,
      ruleForm: {
        Name: '', //综合查询
        DeptID: '', //培训单位
        EntryDate: '', //年级
        Degree: '', //学位
        Type: '', //记录类型
        ReportStatus: '', //上报状态
        pageIndex: 1,
        pageSize: '10',
        RoleID: '',
        time: '',
      },
      form: {
        DeptName: '',
        RealName: '',
        Status: '',
        UserID: '',
        entity: '管理员',
        pageIndex: 1,
        pageSize: '10',
      },
      tableData: [],
    };
  },
  methods: {
    // 可编辑危机个案上报
    EditVisited(e){
      this.$refs.childdetail.interveneConsultantevaluation(e,0);
    },
    archives(res) {
      this.$router.push({
        path: '/Crisis/Psychological_archives',
        query: { RoleID: res.RoleID, UserID: res.UserId },
      });
    },
    evaluation(TalkNo, SourceNo,type,KeyNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_evaluation',
        query: { TalkNo: TalkNo , SourceNo : SourceNo,type:type,KeyNo:KeyNo,hy:"hy"},
      });
    },
    Prefabricated_table(KeyNo) {//填写预制表
      this.$router.push({
        path: '/Crisis/Crisis_addmajor_event',
        query: { KeyNo: KeyNo },
      });
    },
    Crisis_Memcon_view(TalkNo,KeyNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_view',
        query: { TalkNo: TalkNo,KeyNo:KeyNo },
      });
    },
    Apply(TalkNo, KeyNo, TalkCrisisGrade) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_apply',
        query: { TalkNo: TalkNo, KeyNo: KeyNo, TalkCrisisGrade: TalkCrisisGrade },
      });
    },
    Crisis_Memcon_audit(TalkNo,KeyNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_audit',
        query: { TalkNo: TalkNo, KeyNo : KeyNo},
      });
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children,
          );
        }
      }
      let _this = this;
      if (obj.fuzi &&  obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    gourl(val) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },
    ceshigorl() {
      this.$router.push('/Crisis/Crisis_intervention?id=111');
    },
    load(form) {
      //列表
      this.$Http_Post('DistressPrediction/UrgentIntervention', {
        pageSize: '10',
        pageIndex: this.ruleForm.pageIndex,
        Name: this.ruleForm.Name,
        DeptID: this.ruleForm.DeptID,
        EntryDate: this.ruleForm.EntryDate,
        Degree: this.ruleForm.Degree,
        RecordType: this.ruleForm.Type,
        RecordStatus: this.ruleForm.ReportStatus,
        RoleID: this.ruleForm.RoleID,
        StartTime: this.StartTime,
        EndTime: this.EndTime,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Count = res.Counts;
        }else{
          this.Global.request_failure(res.Message)
        }
      });
    },

    derivefun(form) {
      //列表
      this.$Http_Post('DistressPrediction/UrgentIntervention', {
        pageSize: '99999999',
        pageIndex: this.ruleForm.pageIndex,
        Name: this.ruleForm.Name,
        DeptID: this.ruleForm.DeptID,
        EntryDate: this.ruleForm.EntryDate,
        Degree: this.ruleForm.Degree,
        RecordType: this.ruleForm.Type,
        RecordStatus: this.ruleForm.ReportStatus,
        RoleID: this.ruleForm.RoleID,
        StartTime: this.StartTime,
        EndTime: this.EndTime,
        ExcelFlag:'1'

      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        }else{
          this.Global.request_failure(res.Message)
        }
      });
    },



    handleCurrentChange(val) {
      //分页点击
      this.ruleForm.pageIndex = val;
      this.load(this.form);
    },
    Go_Review_key(val) {
      sessionStorage.setItem('Crisis_upreport_type', val.row.UrgentStatus);
      this.$router.push({
        path: '../Crisis/Review_key',
        query: {
          id: val.row.userid,
          SourceNo: val.row.SourceNo,
          TableCngResultID: val.row.TableCngResultID,
        },
      });
    },
    resetForm() {
      this.ruleForm.Name = '';
      this.ruleForm.DeptID = '';
      this.ruleForm.EntryDate = '';
      this.ruleForm.Degree = '';
      this.ruleForm.ReportType = '';
      this.ruleForm.ReportState = '';
      this.ruleForm.pageIndex = 1;
      this.ruleForm.ReportStatus = '';
      this.ruleForm.Type = '';
      this.StartTime = '';
      this.EndTime = '';
      localStorage.setItem('Crisis_Intervent',JSON.stringify(this.ruleForm))
      this.load();
    },
    onSelect() {
      this.ruleForm.pageIndex = 1;
      localStorage.setItem('Crisis_Intervent',JSON.stringify(this.ruleForm))
      this.load();
    },
    Memcon_modify(UserId, TalkNo, keyNo) {
      this.$router.push({ path: '/Crisis/Memcon_modify', query: { UserId: UserId, TalkNo: TalkNo, keyNo: keyNo } });
    },
    jump(UserId, TalkNo, KeyNo) {
      this.$router.push({ path: '/Crisis/Memcon', query: { UserId: UserId, TalkNo: TalkNo, KeyNo: KeyNo } });
    },
    jum2p(val) {
      this.$router.push({ path: '/Crisis/report', query: { id: val } });
    },
    jumpMultiparty(val,num){
      this.$router.push({path:'/Crisis/Multiparty',query:{KeyNo:num==0?val.KeyNo:val.MTalk,num:num}})
    }
  },

  mounted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate();
    this.EndTime = year + '-'+ month + '-' + day
    this.StartTime = year-1 + '-'+ month + '-' + day
    if(localStorage.getItem('Crisis_Intervent')){
      this.ruleForm = JSON.parse(localStorage.getItem('Crisis_Intervent'))
    }
    this.ruleForm.RoleID = sessionStorage.getItem('RoleID');
    this.load(this.form);
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
      DeptID: '',
      content: '',
    }).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.ruleForm.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
      }
    });
  },
  filters: {
    dateFormat(datetime) {
      var dt = new Date(datetime);
      var y = dt.getFullYear();
      var M = dt.getMonth() + 1;
      var d = dt.getDate();
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds();
      return `${y}-${M}-${d} ${h}:${m}:${s}`;
    },
  },
};
</script>
<style>
.Crisis_upreport button {
  margin-bottom: 20px;
}
.Crisis_upreport .cell span {
  margin-left: 10px;
  text-align: center;
}
.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>
